import * as Icons from "@mui/icons-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShop,
  faFileInvoiceDollar,
  faDollarSign,
} from "@fortawesome/free-solid-svg-icons";
import {
  roleConstants as roles,
  subscriptionConstants as plans,
  hasSubscription,
} from "core/utils/roleUtils";

export const supplierAdminMenu = [
  {
    id: "menu_alerts",
    label: "Alerts",
    link: "/alerts",
    icon: <Icons.NotificationImportant />,
  },
  {
    id: "menu_dashboard",
    label: "Dashboard",
    link: "/dashboard",
    icon: <Icons.Dashboard />,
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    id: "menu_properties",
    label: "Properties",
    link: "/properties",
    icon: <Icons.MapsHomeWorkOutlined />,
  },
  {
    id: 24,
    label: "Builders",
    link: "/supplier/connections",
    icon: <Icons.Diversity2Outlined />,
    roles: [roles.SUPPLIER_ADMIN, roles.SUPPLIER_GENERAL_MANAGER],
  },
  {
    id: "menu_users",
    label: "Users",
    link: "/users",
    icon: <Icons.GroupsOutlined />,
    roles: [roles.SUPPLIER_ADMIN, roles.SUPPLIER_GENERAL_MANAGER],
    // shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    id: "menu_reports",
    label: "Reports",
    link: "/reports",
    icon: <Icons.Summarize />,
    roles: [roles.SUPPLIER_ADMIN, roles.SUPPLIER_GENERAL_MANAGER],
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    id: "menu_financials",
    label: "Financials",
    link: "/supplier/financials",
    icon: <Icons.PaidOutlined />,
    roles: [roles.SUPPLIER_ADMIN, roles.SUPPLIER_GENERAL_MANAGER],
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  // {
  //   id: 26,
  //   label: "Estimates",
  //   // link: "/estimatesApprovals",
  //   link: "/supplier/estimations",
  //   icon: <Icons.ApprovalOutlined />,
  //   roles: [roles.SUPPLIER_ADMIN, roles.SUPPLIER_GENERAL_MANAGER],
  // },
  // {
  //   id: `menu_supplier_change_order`,
  //   label: "Change Orders",
  //   // link: "/changeRequests",
  //   link: "changeOrders",
  //   icon: <Icons.BorderAllOutlined />,
  //   roles: [roles.SUPPLIER_ADMIN, roles.SUPPLIER_GENERAL_MANAGER],
  //   shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  // },
  {
    id: `menu_signout`,
    label: "Signout",
    link: "/login",
    icon: <Icons.LogoutOutlined />,
    onClick: () => {
      localStorage.removeItem("token");
    },
  },
];
